/** Deletions in flight at once: keeps a large selection off the API without making it crawl. */
export const DELETE_CONCURRENCY = 4;

export type DeleteOutcome = { succeeded: string[]; failed: string[] };

/**
 * Attempts every id with at most `DELETE_CONCURRENCY` calls in flight; one failure never stops the rest.
 */
export const deleteBackupsPool = async <TResult>(
  backupIds: readonly string[],
  deleteOne: (backupId: string) => Promise<TResult>,
): Promise<DeleteOutcome> => {
  const outcome: DeleteOutcome = { succeeded: [], failed: [] };
  const queue = [...backupIds];

  const worker = async () => {
    for (let backupId = queue.shift(); backupId !== undefined; backupId = queue.shift()) {
      try {
        await deleteOne(backupId);
        outcome.succeeded.push(backupId);
      } catch {
        outcome.failed.push(backupId);
      }
    }
  };

  await Promise.all(Array.from({ length: Math.min(DELETE_CONCURRENCY, queue.length) }, worker));
  return outcome;
};
